import { Routes, Route } from 'react-router-dom'
import { HomePage } from './pages/HomePage'
import { SessionPage } from './pages/SessionPage'
import { JoinPage } from './pages/JoinPage'
import { UserGuidePage } from './pages/UserGuidePage'
import { Layout } from './components/Layout'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/session/:sessionId" element={<SessionPage />} />
        <Route path="/join/:sessionId" element={<JoinPage />} />
        <Route path="/guide" element={<UserGuidePage />} />
      </Routes>
    </Layout>
  )
}

export default App